<div class="row">

  <a uiSref="a.calculation.list" [uiParams]="{id: process.id}" ngbTooltip="Zurück">
    <h2><i class="fa fa-chevron-left"></i>&nbsp;{{ process.name }} - {{ layout.name }}</h2>
  </a>

  <button class="btn btn-default" (click)="create()"><i class="fa fa-plus fa-2x"></i></button>

</div>


<div class="row">
  &nbsp;
</div>

<table class="max-w-full">
  <thead>
    <tr>
      <th>&nbsp;</th>
      @for (header of headers; track header) {
        <th class="font-normal p-1"
          [ngClass]="{'align-right': header?.validator !== 'STRING'}"
          >
          {{ header.name }}
        </th>
      }
      <th>&nbsp;</th>
    </tr>
  </thead>
  <tbody>
    @for (row of table; track row; let parentIndex = $index) {
      <tr>
        <td class="align-right pl-1 pr-1" [ngClass]="{active: parentIndex === active}" (click)="setActive(parentIndex)">
          {{ parentIndex + 1 }}
        </td>
        @for (column of row; track column; let index = $index) {
          <td [ngClass]="{'red_alert': parentIndex === active}">
            <input type="text"
              name="row-{{ column.id }}"
              class="w-full pt-1 pb-1 pl-2 pr-2 border bg-transparent"
              [ngClass]="{red_alert: column.error, 'align-right': column?.field?.validator !== 'STRING'}"
              [(ngModel)]="column.value"
              (change)="edit(column)">
          </td>
        }
        <td>
          @if (parentIndex === active) {
            <i class="fa fa-trash fa-2x click" (click)="deleteRow(parentIndex)"></i>
          }
        </td>
      </tr>
    }
  </tbody>
</table>
